import React, { useEffect, useState } from "react";

// import lightmodelogo from "../assets/new-images/lightmodelogo.png";
import simplifyte from "../assets/new-images/simplifyte.com.png";
import darkmodelogo from "../assets/new-images/darkmodelogo.png";
import favicon from "../assets/new-images/favicon.png";
import favicondark from "../assets/new-images/favicon-dark.png";
// import BrandAssets from "../assets/new-images/Simplifyte Brand Assets.zip";

import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";
import { Helmet } from "react-helmet-async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faCopy } from "@fortawesome/free-solid-svg-icons";

// import BrandAssets from "../../../Websitesimplifyte/public/assets/brand/All_Logo_Types.zip"

const Brand = () => {
  const [copiedColor, setCopiedColor] = useState(null);

  const colors = [
    {
      name: "White",
      rgb: "RGB : 255, 255, 255",
      hexa: "HEX : #FFFFFF",
      logono:
        "logo-one border-b-[3px] dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 shadow dark:shadow-gray-800 rounded-xl  dark:bg-slate-800 bg-white",
    },
    {
      name: "Simplifyte Blue",
      rgb: "RGB : 9, 58, 91",
      hexa: "HEX : #093A5B",
      logono: "logo-two",
    },
    {
      name: "SubBlue",
      rgb: "RGB : 42, 156, 215",
      hexa: "HEX : #2A9CD7",
      logono: "logo-three",
    },
  ];

  const handleCopy = (colorCode) => {
    navigator.clipboard
      .writeText(colorCode)
      .then(() => {
        setCopiedColor(colorCode);
        setTimeout(() => {
          setCopiedColor(null);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <>
      <Helmet>
        <title>Brand Guidelines - Simplifyte</title>

        {/* Open Graph meta */}
        <meta property="og:title" content="Brand Guidelines - Simplifyte" />
        <meta
          name="description"
          property="og:description"
          content="Resources for presenting the Simplifyte brand consistently and professionally."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.simplifyte.com/brand" />

        {/* Viewport for responsive design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Simplifyte, brand guidelines, brand assets, logo usage, brand identity, corporate branding"
        />
      </Helmet>

      <HeaderMenu />
      <section className="brand-page py-36 mt-[50px]">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className=" mb-95 ">
                <div className="text-center main-top-div">
                  <h1 className="brand_page-heading">
                    Simplifyte Brand Guidelines
                  </h1>
                  <p className="brand_page-para">
                    Resources for presenting the Simplifyte brand consistently
                    and professionally.
                  </p>

                  <a
                    // href="/assets/brand/All_Logo_Types.zip"
                    // className="download-brand"
                    // href="/assets/Simplifyte_Logos.zip"
                    href="/assets/brand/Simplifyte_Logos.zip"
                    className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base
                           text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full 
                           after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600
                            hover:text-indigo-600 after:bg-indigo-600 duration-500"
                    download="simplifyte.com.zip"
                  >
                    Download Brand Assets
                  </a>

                  <div className="custom-hr-line"></div>
                </div>

                <div className="content-brand">
                  <div className="content-brand-item">
                    <h2 className="brand-content-title">Naming</h2>
                    <p className="brand-content-desc">
                      “Simplifyte” is always written as a single word, with a
                      capital “S”. It refers to both our company and our
                      workflow management platform (not “Simplifyte app” or “The
                      Simplifyte Platform”).
                    </p>
                  </div>

                  <div className="content-brand-item">
                    <h2 className="brand-content-title">Usage</h2>
                    <p className="brand-content-desc">
                      Please allow ample space around Simplifyte brand assets.
                      Whether large or small, our logo and wordmark should have
                      room to breathe. Avoid cramped or visually cluttered
                      layouts.
                    </p>
                    <p className="brand-content-desc  mb-3">
                      All brand graphics are proprietary assets protected under
                      applicable intellectual property laws. Please do not:
                    </p>
                    <p className="brand-content-note">
                      Alter the graphics in any way. Display them in a way that
                      suggests a relationship, endorsement, or affiliation with
                      Simplifyte. Use our assets as part of your product,
                      service, or company name. Combine Simplifyte’s brand
                      assets with other logos or graphics without written
                      consent. Need help or clarity? Reach out to us — we’re
                      here to support respectful and consistent brand usage.
                    </p>
                  </div>

                  <div className="content-brand-item linear-wordmark">
                    <h2 className="brand-content-title">Simplifyte Wordmark</h2>
                    <p className="brand-content-desc mb-3">
                      The Simplifyte wordmark should be used in all references
                      to the brand, wherever space permits. It combines our
                      logomark with the full brand name to maintain strong
                      recognition and brand consistency.
                    </p>
                    <p className="brand-content-desc mb-3">
                      We recommend using the monochrome version of the wordmark
                      on contrasting backgrounds for clarity and impact. Our
                      brand color variations are designed to work seamlessly
                      across light and dark themes.
                    </p>
                    <p className="brand-content-desc mb-3">
                      Approved color combinations include:
                    </p>
                    <div className="logos-download">
                      <a
                        href={simplifyte}
                        className="logo-item logo-one border-b-[3px] dark:border-gray-700 hover:border-indigo-600
                         dark:hover:border-indigo-600 shadow dark:shadow-gray-800 rounded-xl  dark:bg-slate-800
                          bg-white "
                        // download="simplifyte.com.png"
                        download="simplifyte.com.png"
                      >
                        <div className="logo-single">
                          <img src={simplifyte} alt="Simplifyte" />
                        </div>
                        <div className="download-btn">
                          <div className="btn btn-download">
                            <FontAwesomeIcon icon={faDownload} />
                            Download
                          </div>
                        </div>
                      </a>
                      <a
                        href={darkmodelogo}
                        className="logo-item logo-two"
                        download="simplifyte.com.png"
                      >
                        <div className="logo-single">
                          <img src={darkmodelogo} alt="Simplifyte" />
                        </div>
                        <div className="download-btn">
                          <div className="btn btn-download">
                            <FontAwesomeIcon icon={faDownload} />
                            Download
                          </div>
                        </div>
                      </a>
                      <a
                        href={darkmodelogo}
                        className="logo-item logo-three"
                        download="simplifyte.com.png"
                      >
                        <div className="logo-single">
                          <img src={darkmodelogo} alt="Simplifyte" />
                        </div>
                        <div className="download-btn">
                          <div className="btn btn-download">
                            <FontAwesomeIcon icon={faDownload} />
                            Download
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className="content-brand-item linear-logo">
                    <h2 className="brand-content-title">Simplifyte Logo</h2>
                    <p className="brand-content-desc mb-3">
                      The Simplifyte logomark is a minimal, recognizable symbol
                      that can be used in tight layouts, grid-based designs, or
                      logo-only placements where space is limited. It represents
                      Simplifyte’s forward-thinking, streamlined approach to
                      productivity and collaboration.
                    </p>
                    <div className="logos-download">
                      <a
                        href={favicon}
                        className="logo-item logo-one border-b-[3px] dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 
                        shadow dark:shadow-gray-800 rounded-xl  dark:bg-slate-800 bg-white"
                        download="simplifyte.com.png"
                      >
                        {/* logo-item logo-one border-b-[3px] dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 shadow dark:shadow-gray-800 rounded-xl  dark:bg-slate-800 hover:bg-white dark:hover:bg-slate-900 */}
                        <div className="logo-single">
                          <img src={favicon} alt="Simplifyte" />
                        </div>
                        <div className="download-btn">
                          <div className="btn btn-download">
                            <FontAwesomeIcon icon={faDownload} />
                            Download
                          </div>
                        </div>
                      </a>
                      <a
                        href={favicondark}
                        className="logo-item logo-two"
                        download="simplifyte.com.png"
                      >
                        <div className="logo-single">
                          <img src={favicondark} alt="Simplifyte" />
                        </div>
                        <div className="download-btn">
                          <div className="btn btn-download">
                            <FontAwesomeIcon icon={faDownload} />
                            Download
                          </div>
                        </div>
                      </a>
                      <a
                        href={favicondark}
                        className="logo-item logo-three"
                        download="simplifyte.com.png"
                      >
                        <div className="logo-single">
                          <img src={favicondark} alt="Simplifyte" />
                        </div>
                        <div className="download-btn">
                          <div className="btn btn-download">
                            <FontAwesomeIcon icon={faDownload} />
                            Download
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className="content-brand-item linear-icon">
                    <h2 className="brand-content-title">Simplifyte Icon</h2>
                    <p className="brand-content-desc mb-3">
                      The Simplifyte icon is a stylized symbol representing
                      motion, direction, and simplicity. Use it in tight spaces
                      like social media profiles, app launchers, or chip-style
                      UI components.
                    </p>
                    <div className="logos-download">
                      <a
                        href={favicon}
                        className="logo-item logo-one border-b-[3px]
                         dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 
                         shadow dark:shadow-gray-800 rounded-xl  bg-white hover:bg-slate-800
                          dark:hover:bg-slate-900"
                        download="simplifyte.com.png"
                      >
                        {/* className="logo-item logo-one border-b-[3px]
                         dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 
                         shadow dark:shadow-gray-800 rounded-xl  dark:bg-slate-800 hover:bg-white
                          dark:hover:bg-slate-900" */}
                        <div className="logo-single">
                          <img
                            className="logo-others"
                            src={favicon}
                            alt="Simplifyte"
                          />
                        </div>
                        <div className="download-btn">
                          <div className="btn btn-download">
                            <FontAwesomeIcon icon={faDownload} />
                            Download
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className="content-brand-item linear-colors">
                    <h2 className="brand-content-title">Colors</h2>
                    <p className="brand-content-desc mb-3">
                      Simplifyte's brand colors are designed to feel modern,
                      clean, and versatile across light and dark modes. These
                      colors work best when used with care and consistency.
                    </p>
                    <p className="brand-content-desc mb-3">
                      Use the primary brand color mainly for patterns or
                      backgrounds, while white, dark blue, and black are ideal
                      for wordmarks and contrast.
                    </p>
                    <div className="logos-download">
                      {/*  */}

                      {colors.map((color, index) => (
                        <div
                          className={`logo-item ${color.logono}`}
                          key={index}
                        >
                          <div className="logo-single color-copy">
                            <span className="color-title">{color.name}</span>
                            <span className="color-rgb">{color.rgb}</span>
                            <span className="color-hexa">{color.hexa}</span>
                          </div>
                          <div className="download-btn">
                            <div
                              className="btn btn-download"
                              onClick={() => handleCopy(color.hexa)}
                            >
                              <FontAwesomeIcon icon={faCopy} />
                              {copiedColor === color.hexa ? "Copied!" : "Copy"}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="custom-hr-line"></div>

                  <div className="last-single-line">
                    <p>
                      We’re sketching the future of Simplifyte—pen still in
                      hand. Wanna help draw the next line? ✏️
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CustomFooter />
    </>
  );
};

export default Brand;
